var map = {
	"./App_store.svg": 492,
	"./Arrow-blue.svg": 573,
	"./Arrow-gray.svg": 574,
	"./Google_play.svg": 493,
	"./Logo_apoteka.svg": 575,
	"./New_logo.svg": 576,
	"./Telegram-white.svg": 577,
	"./adaptive-cart.svg": 578,
	"./apoteka-logo--adaptive.svg": 579,
	"./apoteka-logo.svg": 580,
	"./arrow_back.svg": 581,
	"./basket-cart.svg": 582,
	"./basket.svg": 583,
	"./btn-x.svg": 584,
	"./burger-close.svg": 585,
	"./burger-search.svg": 586,
	"./button-arrow.svg": 587,
	"./button.svg": 588,
	"./cart.svg": 589,
	"./checked-disabled.svg": 590,
	"./checked.svg": 591,
	"./circle-list.svg": 592,
	"./clock-icon.svg": 593,
	"./close-gray.svg": 594,
	"./close-modal.svg": 595,
	"./delete.svg": 596,
	"./delivery-tooltip.svg": 494,
	"./delivery.svg": 597,
	"./download.svg": 342,
	"./download_icon.svg": 598,
	"./edit.svg": 599,
	"./empty-cart.svg": 484,
	"./help-btn.svg": 600,
	"./location-icon.svg": 601,
	"./location.svg": 478,
	"./logo-mobile.svg": 602,
	"./logo.svg": 603,
	"./loop.svg": 604,
	"./minus-small.svg": 605,
	"./minus.svg": 606,
	"./pagination-left-h.svg": 607,
	"./pagination-left.svg": 608,
	"./pagination-right-h.svg": 609,
	"./pagination-right.svg": 610,
	"./pdf-icon.svg": 611,
	"./pharmacy-no-image.svg": 612,
	"./pharmacy-partner.svg": 476,
	"./pharmacy-phone-icon.svg": 613,
	"./phone-big.svg": 479,
	"./phone.svg": 614,
	"./plus-small.svg": 615,
	"./plus.svg": 616,
	"./product-available.svg": 617,
	"./product-empty.svg": 618,
	"./product-fast-delivery.svg": 619,
	"./product-in-stock.svg": 620,
	"./product-none.svg": 621,
	"./product-receipt.svg": 622,
	"./product-stock.svg": 623,
	"./rating-star.svg": 624,
	"./red-star.svg": 625,
	"./red-stars.svg": 626,
	"./rk-logo.svg": 627,
	"./sad-cart.svg": 495,
	"./search-icon.svg": 628,
	"./settings.svg": 629,
	"./shevron.svg": 630,
	"./sign-in.svg": 480,
	"./slider-arrow-left.svg": 631,
	"./slider-arrow-right.svg": 632,
	"./star-empty.svg": 633,
	"./star.svg": 634,
	"./trash.svg": 635,
	"./website-icon.svg": 636,
	"./website-sphere.svg": 637,
	"./whatsapp.svg": 481,
	"./whatsup-white.svg": 638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 572;